export default class infoRU{
    constructor(_wrapper: HTMLElement) {
        this.templ(_wrapper);
    }

    templ(_parent: HTMLElement){
        _parent.classList.add('footer-info-ru');
        _parent.innerHTML= `
        <div class="footer-rating">
            <img src="https://assets.playnccdn.com/resource/lineage2mru/footer-rating-rars.png">
            <img src="https://assets.playnccdn.com/resource/lineage2mru/footer-rating-pegi.png">
        </div>
        `;
    }
}